<div class="container">
    <h2 mat-dialog-title>Assign Permission Group</h2>

    <mat-dialog-content [formGroup]="form" class="dialog-content">
        <p>Assign a permission group to <strong>{{ data.name }}</strong>.</p>

        <!-- Mat form input -->
        <mat-form-field appearance="fill">
            <mat-label>Permission Group</mat-label>

            <mat-select formControlName="group">
                <mat-option *ngFor="let group of groups" [value]="group">{{ group }}</mat-option>
            </mat-select>

            <mat-error *ngIf="form.get('group')?.hasError('required')">A group is required</mat-error>
        </mat-form-field>
    </mat-dialog-content>

    <mat-dialog-actions>
        <button mat-button (click)="close()">Cancel</button>
        <button mat-flat-button color="primary" (click)="submit()" [disabled]="form.invalid">Submit</button>
    </mat-dialog-actions>
</div>